module.exports = __webpack_public_path__ + "img/党建.da70bb76.jpg";